import { Copy } from '@ev-tech/ui-core-components/Copy';
import { Button } from '@ev-tech/ui-core-components/Button';

import type { ConversationMessage, PageSkill } from '../../types';
import { useChatbotSession } from '../../providers/ChatbotProvider';

import styles from './SkillConfirmation.module.css';

export const SkillConfirmation = ({ message, skill }: { message: ConversationMessage; skill: PageSkill }) => {
  const { t, confirmAction, declineAction, isPending, isConfirming } = useChatbotSession();
  const confirmation = typeof skill.confirmation === 'object' ? skill.confirmation : undefined;
  const preview = confirmation?.previewField ? message.skillData?.[confirmation.previewField] : undefined;

  return (
    <div className={styles.card} role="group" aria-labelledby={`chatbot-message-${message.id}`}>
      {preview && (
        <blockquote className={styles.preview}>
          <Copy size="m" text={preview} />
        </blockquote>
      )}
      <div className={styles.actions}>
        <Button
          type="button"
          size="small"
          variant="primary"
          label={t(confirmation?.confirmLabelKey ?? 'chatbot.skillConfirm')}
          disabled={isPending || isConfirming}
          onClick={() => void confirmAction(message.id)}
        />
        <Button
          type="button"
          size="small"
          variant="secondary"
          label={t('chatbot.skillDecline')}
          disabled={isPending || isConfirming}
          onClick={() => declineAction(message.id)}
        />
      </div>
    </div>
  );
};
